module.exports = __webpack_public_path__ + "static/3-b19736cbf2a275d9fc17096c94127aa8.jpg";